import React, { useEffect, useRef, useState } from 'react'
import { Button, Input, Modal, Form, InputNumber, Select, Row, Col } from 'antd'
import { useAccountProfile } from '~/views/redux/hooks/useAccountProfile'
import { USER_INFO } from '~/common/constants'

export default function ModalTransferNFT(props) {
  const { name, action, t, tokenID, loadingModal, item, quanlityTotal } = props
  const userStorage = JSON.parse(localStorage.getItem(USER_INFO) || null)
  const [form] = Form.useForm()
  const [searchValue, setSearchValue] = useState('');
  const [displayValue, setDisplayValue] = useState(''); 
  const okButtonStyle = {
    fontWeight: 'bold',
    padding: '10px',
    color: '#fff',
    backgroundColor: '#FAA52C',
    width: '50%',
    height: '48px',
    borderRadius: '4px',
  }
  const cancelButtonStyle = {
    fontWeight: 'bold',
    padding: '10px',
    color: '#fff',
    width: '50%',
    height: '48px',
  }
  const {
    actions,
    data: { allAddressUser },
  } = useAccountProfile()

  useEffect(() => {
    const params = {
      wallet_address: userStorage?.address_wallet,
    }
    actions.getAllAddressUser(params)
  }, [])
  
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      let { receiver, quantity } = values
      
      if (typeof receiver === 'string' && receiver.includes('Wallet address:')) {
        const match = receiver.match(/Wallet address:\s*(0x[a-fA-F0-9]{40})/)
        if (match) receiver = match[1]
      } else if (receiver?.startsWith('Name: ')) {
        const userName = receiver.replace('Name: ', '').trim();
        const matchedUser = allAddressUser?.find(user => user.user_name === userName);
        if (matchedUser) {
          receiver = matchedUser.address_wallet;
        }
      } else {
        const matchedUser = allAddressUser?.find(user => user.user_name === receiver)
        if (matchedUser) {
          receiver = matchedUser.address_wallet
        }
      }
      
      action?.handleOk(receiver, quantity)
    } catch (error) {
      console.error('Validation Failed:', error)
    }
  }

  const handleCancel = () => {
    action?.handleCancel()
  }

  useEffect(() => {
    if (action?.isModalOpen) {
      form.resetFields()
      setSearchValue('')
      setDisplayValue('')
    }
  }, [action?.isModalOpen]) 
  
  const generateItemList = (listAddWhiteList) =>
    listAddWhiteList?.map((item) => ({
      key: item?._id,
      label: `Name: ${item?.user_name}`, 
      value: item?.user_name,
      name: item?.user_name,
      address: item?.address_wallet,
    }))
  const handleSearch = (value) => {
    setSearchValue(value);
    setDisplayValue(value);
  };

  const handleChange = (value) => {
    const selectedUser = allAddressUser?.find(user => user.user_name === value);
    
    if (selectedUser) {
      const addressPattern = /^0x[a-fA-F0-9]{40}$/;
      const isFullAddress = addressPattern.test(searchValue);
      
      if (isFullAddress && searchValue.toLowerCase() === selectedUser.address_wallet.toLowerCase()) {
        const fullDisplayValue = `Name: ${selectedUser.user_name}\nWallet address: ${selectedUser.address_wallet}`;
        setDisplayValue(fullDisplayValue);
        form.setFieldsValue({ receiver: fullDisplayValue });
      } else {
        const nameOnlyDisplay = `Name: ${selectedUser.user_name}`;
        setSearchValue(selectedUser.user_name);
        setDisplayValue(nameOnlyDisplay);
        form.setFieldsValue({ receiver: nameOnlyDisplay });
      }
    } else {
      setSearchValue(value);
      setDisplayValue(value);
      form.setFieldsValue({ receiver: value });
    }
  };

  const handleBlur = async () => {
    if (!searchValue) {
      setDisplayValue('');
      form.setFieldsValue({ receiver: undefined });
      return;
    }
    const addressPattern = /^0x[a-fA-F0-9]{40}$/;
    
    if (addressPattern.test(searchValue)) {
      const matchedUser = allAddressUser?.find(user => user.address_wallet === searchValue);
      
      if (matchedUser) {
        const fullDisplayValue = `Name: ${matchedUser.user_name}\nWallet address: ${searchValue}`;
        setDisplayValue(fullDisplayValue);
        form.setFieldsValue({ receiver: fullDisplayValue });
      } else {
        setDisplayValue(searchValue);
        form.setFieldsValue({ receiver: searchValue });
      }
    } else {
      const matchedUser = allAddressUser?.find(user => 
        user.user_name.toLowerCase().includes(searchValue.toLowerCase())
      );
      
      if (matchedUser && searchValue.toLowerCase() === matchedUser.user_name.toLowerCase()) {
        const nameDisplayValue = `Name: ${matchedUser.user_name}`;
        setDisplayValue(nameDisplayValue);
        form.setFieldsValue({ receiver: nameDisplayValue });
      } else {
        setDisplayValue(searchValue);
        form.setFieldsValue({ receiver: searchValue });
      }
    }

    try {
      await form.validateFields(['receiver']); 
    } catch (err) {
      console.error('Validation error on blur:', err);
    }
  };

  const filteredOptions = allAddressUser?.filter(user => {
    if (!searchValue) return true;

    const searchLower = searchValue.toLowerCase();
    const addressPattern = /^0x[a-fA-F0-9]{40}$/;
    const isFullAddress = addressPattern.test(searchValue);

    if (isFullAddress) {
      return user.address_wallet?.toLowerCase() === searchLower;
    } else {
      return user.user_name?.toLowerCase().includes(searchLower);
    }
  })?.map(item => ({
    key: item._id,
    label: `Name: ${item.user_name}`,
    value: item.user_name,
    name: item.user_name,
    address: item.address_wallet,
  })) || [];
  
  return (
    <>
      <Form form={form} preserve={false}>
        <Modal
          key={tokenID}
          width={655}
          centered
          title={
            <h3 className="flex justify-center text-xl font-bold">
              {t('modal.transferNFT.title')}
            </h3>
          }
          open={action?.isModalOpen}
          onCancel={handleCancel}
          footer={[
            <div key="buttons" className="flex justify-center">
              <Button
                key="cancel"
                onClick={handleCancel}
                style={cancelButtonStyle}
              >
                {t('modal.transferNFT.cancel')}
              </Button>
              <Button
                key="ok"
                type="primary"
                style={okButtonStyle}
                loading={loadingModal}
                onClick={handleSubmit}
              >
                {t('modal.transferNFT.ok')}
              </Button>
            </div>,
          ]}
        >
          <div className="pb-5 text-[16px]">
            {t('modal.transferNFT.description', {
              name: `${name}`,
            })}
          </div>
          <div className="text-[16px]">{t('modal.transferNFT.receiver')}</div>
          <div className="py-2">
            <Form.Item
              name="receiver"
              rules={[
                {
                  required: true,
                  message: t('common.schema.required'),
                },
                () => ({
                  validator(rule, value) {
                    let addressToValidate = value;
                    
                    if (value?.includes('Wallet address: ')) {
                      const lines = value.split('\n');
                      const addressLine = lines.find(line => line.startsWith('Wallet address: '));
                      if (addressLine) {
                        addressToValidate = addressLine.replace('Wallet address: ', '').trim();
                      }
                    } else if (value?.startsWith('Name: ')) {
                      const userName = value.replace('Name: ', '').trim();
                      const matchedUser = allAddressUser?.find(user => user.user_name === userName);
                      if (matchedUser) {
                        addressToValidate = matchedUser.address_wallet;
                      }
                    } else {
                      const matchedUser = allAddressUser?.find(user => user.user_name === value);
                      if (matchedUser) {
                        addressToValidate = matchedUser.address_wallet;
                      }
                    }
                    
                    const addressPattern = /^0x[a-fA-F0-9]{40}$/
                    if (addressToValidate && !addressPattern.test(addressToValidate)) {
                      return Promise.reject(t('common.schema.invalidAddress'))
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <Select
                mode="combobox"
                allowClear
                placeholder={t('modal.transferNFT.placeholder_receiver')}
                className="addUserList"
                style={{ 
                  height: 'auto'
                }}
                dropdownStyle={{
                  whiteSpace: 'pre-line'
                }}
                options={filteredOptions}
                showSearch
                filterOption={false}
                onSearch={handleSearch}
                onChange={handleChange}
                onBlur={handleBlur}
                value={displayValue}
                fieldNames={{ label: 'label', value: 'value' }}
              />
            </Form.Item>
            <style dangerouslySetInnerHTML={{
              __html: `
                .addUserList .ant-select-selector {
                  white-space: pre-line !important;
                  font-size: 13px !important;
                }
                .addUserList .ant-select-selection-item {
                  white-space: pre-line !important;
                  color: #000 !important;
                  font-family: Rexliafree !important;
                  font-size: 13px !important;
                }
                .addUserList .ant-select-selector input {
                  color: #000 !important;
                  caret-color: transparent !important;
                  font-size: 13px !important;
                }
                .ant-select-dropdown .ant-select-item-option-content {
                  color: #FFFFFF !important;
                  font-family: Rexliafree !important;
                  font-size: 13px !important;
                }
              `
            }} />
          </div>
          {quanlityTotal && quanlityTotal > 0 && (
            <>
              <div className="flex justify-between">
                <div className="text-[16px]">
                  {t('modal.transferNFT.quantity')}
                </div>
                <div>
                  {t('modal.transferNFT.max', {
                    quanlityTotal: quanlityTotal,
                  })}
                </div>
              </div>
              <div className="py-2">
                <Form.Item
                  name="quantity"
                  rules={[
                    {
                      required: true,
                      message: t('common.schema.required'),
                    },
                    () => ({
                      validator(rule, value) {
                        if (value && value > quanlityTotal) {
                          return Promise.reject(
                            t('common.schema.totalQuantity'),
                          )
                        }
                        if (value === 0) {
                          return Promise.reject(
                            t('common.schema.quantityNumeric'),
                          )
                        }
                        if (value && value <= 0) {
                          return Promise.reject(
                            t('common.schema.quantityNumeric'),
                          )
                        }
                        const integerPattern = /^-?\d+$/
                        if (value && !integerPattern.test(value)) {
                          return Promise.reject(
                            t('common.schema.mustBeNumeric'),
                          )
                        }
                        const numberPattern = /^-?\d+(\.\d+)?$/
                        if (value && !numberPattern.test(value)) {
                          return Promise.reject(
                            t('common.schema.mustBeNumeric'),
                          )
                        } else if (value > item?.quantity) {
                          return Promise.reject(t('common.schema.insufficient'))
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                >
                  <Input
                    maxLength={7}
                    autoComplete="off"
                    className=" input-numberSell"
                    placeholder={t('modal.transferNFT.placeholder_quantity')}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                  />
                </Form.Item>
              </div>
            </>
          )}
        </Modal>
      </Form>
    </>
  )
}